import React from 'react';
import s from './s.module.less';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import OptCover from './images/serviceImage.png';
import cls from 'classnames';
import usePPAChanneld from 'hooks/usePPAChanneld';

interface IProps {
    setOnboardingPopupStep: (step: number) => void;
    onClosePopup: () => void;
    isAvailabilitySetUpCompleted?: boolean;
    isKlarityServiceSetUpCompleted?: boolean;
}

const ServiceNAblility = ({
    setOnboardingPopupStep,
    onClosePopup,
    isAvailabilitySetUpCompleted,
    isKlarityServiceSetUpCompleted,
}: IProps) => {
    const navigate = useNavigate();
    const [ppaId, loadingPPA] = usePPAChanneld();
    return (
        <div className={s.wrap}>
            <div className={s.playerBox}>
                <div className={s.closeIcon} onClick={onClosePopup} />
                <div className={s.player}>
                    <img src={OptCover} alt="" />
                </div>
            </div>
            <div className={s.content}>

                <div className={cls(s.title, (isAvailabilitySetUpCompleted && isKlarityServiceSetUpCompleted) && s.completeIcon)}>Set up your services & availability – never miss a booking</div>
                <div className={s.desc}>Make it easy for patients to schedule with you by connecting your calendar and listing your services. Avoid double bookings, reduce no-shows, and get booked at the right times.</div>
                <Button
                    className={s.stepDirBtn}
                    onClick={() => {
                        if (!isKlarityServiceSetUpCompleted) {
                            navigate(`/${PATH.SERVICE_SETTING}`);
                        } else {
                            navigate(`${PATH.DASHBOARD}/${PATH.CALENDAR}`);
                        }
                    }}
                >
                    Set up now
                </Button>

            </div>
            <div className={s.footer}>
                <div className={s.step}>Step 2 of 4</div>
                <div className={s.btns}>
                    <Button style={{ width: '120px' }} onClick={() => setOnboardingPopupStep(1)}>Previous</Button>
                    <Button style={{ width: '120px' }} type="primary" onClick={() => setOnboardingPopupStep(3)}>Next</Button>
                </div>
            </div>
        </div>
    );
};

export default ServiceNAblility;
